import loadInitialRowsFromServer from './loadInitialRowsFromServer';
import refreshSingleFolderCount from 'mini-mail-folder-store/lib/actions/data-loading/refreshSingleFolderCount';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import updateMruTableIdList from '../mruTableList/updateMruTableIdList';
import { MAX_CACHED_ROWS_TO_SHOW_TABLE_LOAD } from './TableLoadingConstants';
import type { LoadMailOptions } from '../../schema/LoadMailOptions';

/**
 * Performs the first load for a mail table
 * @param tableView - the given mail tableView
 * @return a promise that resolves when the load initial table has completed either from server or from cache
 */
export default function loadInitialMailTable(
    tableView: TableView,
    options?: LoadMailOptions
): Promise<void> {
    // load table from cache by setting the currentLoadedIndex
    tableView.currentLoadedIndex = Math.min(
        MAX_CACHED_ROWS_TO_SHOW_TABLE_LOAD,
        tableView.itemIds.length
    );

    refreshSingleFolderCount(tableView.tableQuery.folderId);

    // Update MRU table
    updateMruTableIdList(tableView);

    const tableHasCachedItems = tableView.itemIds.length > 0;
    const loadFromServerPromise = loadInitialRowsFromServer(
        tableView,
        options?.shouldPrefetchFirstNRows
    );

    if (options?.shouldWaitForFreshData) {
        return loadFromServerPromise;
    }

    // Resolve the initial load promise immediately if we're showing cached items, otherwise resolve when the server returns results
    return tableHasCachedItems ? Promise.resolve() : loadFromServerPromise;
}
